import { Link, useNavigate } from "react-router-dom";
import { getWhatsAppPhone } from "../utils/whatsapp";
import { auth } from "../api/firebase";

const siteName = process.env.REACT_APP_SITE_NAME || "GifteKart";

export default function Header() {
  const navigate = useNavigate();

  const scrollToFooter = () => {
    document.getElementById("footer-section")?.scrollIntoView({ behavior: "smooth" });
  };

  const openWhatsApp = () => {
    const phone = getWhatsAppPhone();
    const message = "Hello, I want to know more about your e-cards.";
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const goMyEcards = () => {
    if (auth?.currentUser?.uid) {
      navigate("/my-ecards");
      return;
    }
    navigate("/login", { state: { nextPath: "/my-ecards" } });
  };

  return (
    <header className="gk-header">
      <Link to="/" className="gk-brand" aria-label={`${siteName} home`}>
        <span className="gk-brand-mark" aria-hidden>
          ✦
        </span>
        <span className="gk-brand-text">{siteName}</span>
      </Link>

      <nav className="gk-nav" aria-label="Main">
        <button type="button" className="gk-nav-link gk-nav-btn" onClick={goMyEcards}>
          My eCards
        </button>
        <button type="button" className="gk-nav-link gk-nav-btn" onClick={scrollToFooter}>
          Contact
        </button>
        <button type="button" className="gk-nav-wa" onClick={openWhatsApp}>
          WhatsApp
        </button>
      </nav>
    </header>
  );
}
